import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  CloseButton,
} from "@chakra-ui/react";

export const MessageError = (message: string) => (
  <>
    <Alert status="error" variant="solid">
      <AlertIcon mr={2} />
      <Box flex="1">
        <AlertTitle>Ups!</AlertTitle>
        <AlertDescription display="block">{message}</AlertDescription>
      </Box>
    </Alert>
  </>
);
